// tslint:disable
const PAY_WARRANTY_MX = {
    PAYMENT: 'Pago',
    CANCELLED_WARRANTY: 'Garantía anulada',
    CANCELLED_WARRANTY_TEXT_CONTACT: 'En caso de que consideres que fue un error comunícate con nosotros al',
    CANCELLED_WARRANTY_CONTACT_PHONE: '(55)4161-8830',
    PRICE_WITH_IVA: 'Precio a pagar con iva',
    CARD_NUMBER: 'Número de tarjeta',
    CARD_NAME: 'Nombre del titular',
    CARD_EXPIRATION_DATE: 'Fecha de expiración',
    CARD_CCV: 'CCV',
    PAY_TYPE: 'Tipo de pago',
    PAY: 'Pagar',
    PAYMENR_SUCCESS: 'Pago exitoso',
    PAYMENR_REFUSED: 'Tarjeta no autorizada',
    PAYMENR_REFUSED_TEXT: 'No pudimos procesar el pago, revisa que los datos de la tarjeta sean correctos o intenta ' +
        'con otro método de pago.'
};

// tslint:disable
const GLOBAL = {
    QUOTA: 'Cuota',
    ENTRY: 'Entrada',
    TERM: 'Plazo',
    OFFER: 'Ofertas',
    WHATSAPP: 'Whatsapp',
    SAVE: 'Guardar',
    CLIENT: 'Cliente',
    MONTHS: 'meses',
    CONFIRM: 'Confirmar',
    CALL: 'Llamar',
    EMAIL: 'correo electrónico',
    PASSWORD: 'contraseña',
    DELETE: 'borrar',
    TAB_COMPLETE: 'COMPLETAS',
    TAB_IN_PROCESS: 'EN PROCESO',
    TAB_INCOMPLETE: 'INCOMPLETAS',
    TAB_PENDING: 'PENDIENTES',
    TAB_STATUS: 'ESTADO',
    TAB_OBSERVATIONS: 'OBSERVACIONES',
    ORDER_BY: 'ORDENAR POR:',
    SEARCH: 'Buscar',
    ADD: 'Adicionar',
    BACK: 'Atrás',
    ACCEPT: 'Aceptar',
    AGREED: 'Entendido',
    DONT_SHOW_AGAIN: 'no volver a mostrar',
    SEND: 'Enviar',
    CONTINUE: 'Continuar',
    NAME_LASTNAME: 'Nombre y apellidos',
    NAME: 'Nombres',
    LASTNAME: 'Apellidos',
    CELLPHONE: 'Teléfono celular',
    EDIT: 'EDITAR',
    CHANGE: 'Cambiar Cuenta',
    NO_RESULTS: 'No se encontraron resultados',
    CLOSE: 'Cerrar',
    UPDATE_AVAILABLE: 'Actualización disponible',
    UPDATE_MESSAGE: 'Existe una nueva versión para Motorfy, para continuar usando sus servicios actualiza a la nueva versión.',
    UPDATE_NOW: 'Actualizar ahora',
    SELECT: 'Selecciona',
    RETRY: 'Reintentar',
    ACCEPTED_QUOTE_ID: 'quoteAccepted',
    ACCEPTED_QUOTE: 'ACCEPTED_QUOTE',
    NON_ACCEPTED_QUOTE_ID: 'quoteNotAccepted',
    NON_ACCEPTED_QUOTE: 'NON_ACCEPTED_QUOTE'
};

export {
    PAY_WARRANTY_MX,
    GLOBAL
};